import { makeAutoObservable, runInAction } from 'mobx'
import moment from 'moment'

class storeAchievement {
    achievements = []
    genealogyItems = []
    centurions = {}
    periods = []
    ranks = []
    defaultRank = ''
    selectedRank = ''
    isLoadingCenturion = false

    selectedPeriod = ''

    currentCenturionProfileId = ''

    getPeriodsWithMonthName = () => {
        const months = []
        this.periods.forEach(period => {
            // example period: 2025-11
            // convert 11 to Nov
            const month = moment(period, 'YYYY-MM').format('MMM')
            months.push({
                month: month,
                monthName: month
            })
        })
        return months
    }

    getPeriodWithMonthDigit = () => {
        return this.periods[this.selectedPeriod]
    }

    setPeriods(periods) {
        this.periods = periods
    }

    getPeriods() {
        return this.periods
    }

    setRanks(ranks) {
        this.ranks = ranks
    }

    setAchievements(achievements) {
        runInAction(() => {
            this.achievements = achievements
        })
    }

    getAchievements() {
        return this.achievements
    }

    setGenealogyItems(genealogyItems) {
        this.genealogyItems = genealogyItems
    }

    getGenealogyItems() {
        return this.genealogyItems
    }

    setSelectedPeriod(period) {
        this.selectedPeriod = period
    }

    getSelectedPeriod() {
        return this.selectedPeriod
    }

    getRanks() {
        return this.ranks
    }

    setSelectedRank(rank) {
        this.selectedRank = rank
    }

    getSelectedRank() {
        return this.selectedRank
    }

    getSelectedRankIndex() {
        return this.ranks.indexOf(this.selectedRank)
    }

    selectPreviousRank() {
        const currentIndex = this.getSelectedRankIndex()
        if (currentIndex > 0) {
            this.selectedRank = this.ranks[currentIndex - 1]
        }
    }

    selectNextRank() {
        const currentIndex = this.getSelectedRankIndex()
        if (currentIndex < this.ranks.length - 1) {
            this.selectedRank = this.ranks[currentIndex + 1]
        }
    }

    setCenturions(period, centurions) {
        this.centurions[period] = centurions
    }

    getCenturions(period) {
        return this.centurions[period]
    }

    setIsLoadingCenturion(isLoading) {
        this.isLoadingCenturion = isLoading
    }

    getIsLoadingCenturion() {
        return this.isLoadingCenturion
    }

    setCurrentCenturionProfileId(id) {
        this.currentCenturionProfileId = id
    }

    getCurrentCenturionProfileId() {
        return this.currentCenturionProfileId
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const StoreAchievement = new storeAchievement()

export default StoreAchievement
